(function () {
  'use strict';

  function parseBundles(raw) {
    if (!raw) return [];
    return raw.split(',').map(function (entry) {
      var parts = entry.split('|');
      return {
        price: parseInt(parts[0], 10) || 0,
        save: parseInt(parts[1], 10) || 0,
        match: parts[2] || 'none'
      };
    }).filter(function (b) {
      return b.match !== 'none';
    });
  }

  function matchBundle(bundles, s) {
    for (var i = 0; i < bundles.length; i++) {
      var m = bundles[i].match;
      if (m === 'single_yes' && s.driveway === 'single' && s.sidewalk === 'yes') return bundles[i];
      if (m === 'double_yes' && s.driveway === 'double' && s.sidewalk === 'yes') return bundles[i];
    }
    return null;
  }

  function getConfig() {
    var root = document.querySelector('.a1-page[data-a1-price-single]');
    if (!root) return null;

    return {
      prices: {
        driveway: {
          single: parseInt(root.getAttribute('data-a1-price-single'), 10) || 0,
          double: parseInt(root.getAttribute('data-a1-price-double'), 10) || 0,
          none: 0
        },
        sidewalk: {
          yes: parseInt(root.getAttribute('data-a1-price-sidewalk'), 10) || 0,
          no: 0
        }
      },
      bundles: parseBundles(root.getAttribute('data-a1-bundles'))
    };
  }

  function getSelections() {
    return {
      driveway: document.getElementById('a1-driveway')?.value || 'single',
      sidewalk: document.getElementById('a1-sidewalk')?.value || 'yes'
    };
  }

  function calcIndividual(prices, s) {
    return prices.driveway[s.driveway] + prices.sidewalk[s.sidewalk];
  }

  function calcEstimate() {
    var config = getConfig();
    if (!config) return;

    var s = getSelections();
    var individual = calcIndividual(config.prices, s);
    var bundle = matchBundle(config.bundles, s);
    var priceEl = document.getElementById('a1-estimate-price');
    var saveEl = document.getElementById('a1-estimate-save');

    if (!priceEl) return;

    if (bundle) {
      priceEl.textContent = '$' + bundle.price;
      if (saveEl) {
        saveEl.innerHTML = 'You save <strong>$' + bundle.save + '</strong> with a bundle!';
      }
    } else if (individual > 0) {
      priceEl.textContent = '$' + individual;
      if (saveEl) {
        saveEl.textContent = 'Add more services to unlock bundle savings!';
      }
    } else {
      priceEl.textContent = '$0';
      if (saveEl) saveEl.textContent = 'Select services to get an estimate.';
    }
  }

  function initMenu() {
    var toggle = document.getElementById('a1-menu-toggle');
    var nav = document.getElementById('a1-nav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      nav.classList.toggle('a1-nav--open');
    });

    nav.querySelectorAll('.a1-nav__link').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('a1-nav--open');
      });
    });
  }

  function initEstimator() {
    ['a1-driveway', 'a1-sidewalk'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('change', calcEstimate);
    });
    calcEstimate();
  }

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var href = this.getAttribute('href');
        if (!href || href === '#') {
          e.preventDefault();
          return;
        }
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function initServiceCards() {
    document.querySelectorAll('.a1-service-card').forEach(function (card) {
      var detailsBtn = card.querySelector('[data-action="details"]');
      var detailsLabel = detailsBtn ? detailsBtn.textContent.trim() : 'View Details';

      if (detailsBtn) {
        detailsBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var isOpen = card.classList.toggle('a1-service-card--expanded');
          detailsBtn.textContent = isOpen ? 'Hide Details' : detailsLabel;
          card.setAttribute('aria-expanded', isOpen);
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initEstimator();
    initSmoothScroll();
    initServiceCards();
  });

  document.addEventListener('shopify:section:load', function () {
    initMenu();
    initEstimator();
    initSmoothScroll();
    initServiceCards();
  });
})();
